import { useEffect, useDebugValue, useCallback } from 'react';
import { useMeasuredCookieState } from './useMeasuredCookieState';
function isServerRendering() {
    return typeof document === 'undefined' || typeof window === 'undefined';
}
export function useMeasuredCookie(cookieType, containerRef, { defaultSize: defaultSizeProp, cookieDim = 'both', listenOnWindow, sentinelRef, version = 0 }) {
    const { containerSize, defaultSizeForPlatform, updateContainerSize } = useMeasuredCookieState(cookieType, cookieDim, defaultSizeProp, !!sentinelRef || isServerRendering());
    useDebugValue(containerSize, (size)=>{
        var _size, _size1;
        return `Width: ${(_size = size) === null || _size === void 0 ? void 0 : _size.width}, height: ${(_size1 = size) === null || _size1 === void 0 ? void 0 : _size1.height}`;
    });
    const measureContainerSize = useCallback(()=>{
        function getContainerSize() {
            var _containerElement, _sentinelRef_current, _sentinelRef;
            // We are in browser from here
            const containerElement = containerRef.current;
            const rect = (_containerElement = containerElement) === null || _containerElement === void 0 ? void 0 : _containerElement.getBoundingClientRect();
            if (!rect || !rect.width && !rect.height) {
                return defaultSizeForPlatform;
            }
            const sentinelWidth = (_sentinelRef = sentinelRef) === null || _sentinelRef === void 0 ? void 0 : (_sentinelRef_current = _sentinelRef.current) === null || _sentinelRef_current === void 0 ? void 0 : _sentinelRef_current.getBoundingClientRect().width;
            return {
                // Make sure container is never bigger than parent
                // this allows us to shrink the container :)
                width: sentinelWidth && sentinelWidth < rect.width ? sentinelWidth : rect.width,
                height: rect.height
            };
        }
        const newSize = getContainerSize();
        updateContainerSize(newSize);
    }, [
        containerRef,
        defaultSizeForPlatform,
        sentinelRef,
        updateContainerSize
    ]);
    useEffect(()=>{
        measureContainerSize();
        if (listenOnWindow) {
            window.addEventListener('resize', measureContainerSize);
            return ()=>window.removeEventListener('resize', measureContainerSize);
        }
    }, [
        listenOnWindow,
        measureContainerSize,
        version
    ]);
    return containerSize;
}
